import React from "react";
import { Button } from "components/button";
import { MoveSummaryCard } from "components/MoveSummaryCard";
import "./MoveSummary.scss"
import { FormGroup, Validators, FormBuilder, FormControl } from "react-reactive-form";
import { client } from "App";
import { saveSignatures } from '../../core/services/saveSignatures'
import { makeRequest } from "core/services/payDepositService";
import { isMobile } from "core/utils";
export interface MoveSummaryProps {
    onClick?(): void;
    formControl?: FormControl;
}

export interface MoveSummaryState {
    disable: boolean;
    loading?: boolean
}

class MoveSummary extends React.Component<MoveSummaryProps, MoveSummaryState> {
    constructor(props: MoveSummaryProps) {
        super(props);
        this.state = {
            disable: true,
            loading: false
        };
    }
    getSignature() {
        //debugger;
        // var isAffirm=(localStorage.getItem("isAffirm") || "0");
        // if(this.props.formControl){
        //     if(isAffirm=="1"){
        //         this.props.formControl.setValue("1")
        //     }else{
        //         this.props.formControl.setValue("0")
        //     }
        // }

        if (this.props.onClick) {
            this.props.onClick()

        }
    }

    getSignFlag(sign: any, valid: any) {
        if (sign == "" || !valid) {
            this.setState({ disable: true })
        }
        else {
            this.setState({ disable: false })
        }
    }
    async sendQuoteEmail() {

        var Customer = JSON.parse(localStorage.getItem("customerDetails") || '{}')
        //var Estimator=JSON.parse(localStorage.getItem("EstimatorUserDetails")||'{}')
        var estimator: any = JSON.parse(localStorage.getItem("EstimatorDetails") || "{}")

        var signs = JSON.parse(localStorage.getItem("signs") || "[]");
        var signFirst = signs[0];
        var signSecond = signs[1];
        //signature2:  signSecond.sign
        var params = {
            "customerID": Customer.customerID,
            "moveID": Customer.moveID,
            "MoveDailySheetID": Customer.moveDailySheetID,
            "EstimatorID": Customer.estimatorID,
            "CustomerSignature": localStorage.getItem("estsigns"),
            "EstimatorSignature": "",
            "EstimatorEmail": estimator.email,
            "CustomerEmail": Customer.customerEmail,
            "Body": "",
            "BranchID": Customer.branchID,
            "ZipCodeSameLocation": "no"

        }
        await makeRequest("SendQuoteEmail", params)
            .then(response => {
                //this.setState({ loading: false });
                console.error('SENDQUOTE SUCCESS');
                // if (this.props.onClick) {
                //     this.props.onClick()
                // }
            })
            .catch(error => {
                //this.setState({ loading: false });
                console.error('there was an error!', error.statusText);
            });
        // .catch(function (err) {
        //     this.setState({loading:false});
        //     console.error('there was an error!', err.statusText);
        // });
    }

    saveSignatures(flag: string) {
        //this.setState({ loading: true })
        var Customer = JSON.parse(localStorage.getItem("customerDetails") || '{}')
        var params = {
            customerID: Customer.customerID,
            moveID: Customer.moveID,
            moveDailySheetID: Customer.moveDailySheetID,
            estimatorID: Customer.estimatorID,
            signature1: localStorage.getItem("estsigns"),
            signature2: ""
        }
        console.log("PARAMS", params)
        this.saveSignaturesAPI(params)
            .then((response) => {
                if (response) {
                    this.sendQuoteEmail();

                    if (this.props.onClick) {
                        this.props.onClick()
                    }
                }
            });
    }

    async saveSignaturesAPI(params: any) {
        return client.query({
            query: saveSignatures, variables: {
                sigInput: {
                    "customerID": params.customerID,
                    "moveID": params.moveID,
                    "moveDailySheetID": params.moveDailySheetID,
                    "estimatorID": params.estimatorID,
                    "signature1": params.signature1,
                    "signature2": params.signature2
                }
            }
        });
    }
    render() {
        return (
            <div className="todo-container">

                <div className={"paperContainer"} style={{ height: window.innerHeight - 150 }}>
                    <div className="gap short" />
                    <div className="paperworkEst-title">
                        {/* {
                        isSuper ? <h1>Your Super deal move Details</h1>
                            : <h1>Your  Move Details</h1>
                    } */}
                        <h1>Summary of Charges & Services</h1>
                    </div>
                    <MoveSummaryCard getSignFlag={this.getSignFlag.bind(this)} />
                </div>

                <Button
                    text={"Continue"}
                    disable={this.state.disable}
                    onClick={() => this.saveSignatures("1")}
                    color="white"
                // loading={this.state.loading}
                />
            </div>
        );
    }
}

export default MoveSummary;